import { useRef } from "react";
import "./editorialForms.css";

export default function SpotifyForm({ data, onChange }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, audioFile: file, audioFileName: file.name });
    }
  };

  const genres = [
    "Pop",
    "Rock",
    "Hip Hop",
    "R&B",
    "Electronic",
    "Jazz",
    "Classical",
    "Country",
    "Reggae",
    "Latin",
    "K-Pop",
    "Indie",
    "Metal",
    "Blues",
    "Soul",
    "Funk",
    "Gospel",
    "MPB",
    "Sertanejo",
    "Forro",
  ];

  return (
    <div className="editorial_form spotify_form">
      <div className="editorial_form_section">
        <label>
          Arquivo de Musica <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="audio/*,.mp3,.wav,.m4a,.ogg"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.audioFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
              </svg>
              <span>{data.audioFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, audioFile: null, audioFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload da musica</p>
              <span>MP3, WAV, M4A, OGG</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Nome da Musica <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Bohemian Rhapsody"
          value={data?.trackName || ""}
          onChange={(e) => onChange({ ...data, trackName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Artista <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Queen"
          value={data?.artistName || ""}
          onChange={(e) => onChange({ ...data, artistName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Album</label>
        <input
          type="text"
          placeholder="Ex: A Night at the Opera"
          value={data?.albumName || ""}
          onChange={(e) => onChange({ ...data, albumName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Genero</label>
        <div className="genre_chips">
          {genres.slice(0, 12).map((genre) => (
            <span
              key={genre}
              className={`genre_chip ${data?.genre === genre ? "selected" : ""}`}
              onClick={() => onChange({ ...data, genre })}
            >
              {genre}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Link do Spotify (opcional)</label>
        <input
          type="url"
          placeholder="https://open.spotify.com/track/..."
          value={data?.spotifyUrl || ""}
          onChange={(e) => onChange({ ...data, spotifyUrl: e.target.value })}
        />
        <span className="editorial_form_hint">
          Cole o link do Spotify para permitir que outros ouçam
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Por que voce esta compartilhando essa musica?</label>
        <textarea
          placeholder="Conte o que essa musica significa para voce..."
          value={data?.shareReason || ""}
          onChange={(e) => onChange({ ...data, shareReason: e.target.value })}
          rows={2}
          maxLength={280}
        />
        <span className="editorial_form_counter">
          {(data?.shareReason?.length || 0)}/280
        </span>
      </div>

      <div className="editorial_form_tip spotify_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
        </svg>
        <span>
          Compartilhe suas musicas favoritas com seus amigos. O preview sera
          exibido automaticamente se disponivel.
        </span>
      </div>
    </div>
  );
}
